// import { useQuery } from '@tanstack/react-query';
import { X } from 'lucide-react';
import { useEffect, useState } from 'react';
// import { getQuickActionsAppointmentByIdQueryOptions } from '../../api/queries';

interface AppointmentStatusCardProps {
  status: string;
  encounter: any;
  onStatusChange?: (status: 'attended' | 'cancelled') => void;
}

export function AppointmentStatusCard({
  status,
  onStatusChange,
  // encounter
}: AppointmentStatusCardProps) {
  const [currentStatus, setCurrentStatus] = useState(status);
  // const quickAppointments = useQuery(
  //   getQuickActionsAppointmentByIdQueryOptions(encounter.id)
  // );

  useEffect(() => {
    if (status) {
      setCurrentStatus(status);
    }
  }, [status]);

  const handleStatusUpdate = (newStatus: 'attended' | 'cancelled') => {
    setCurrentStatus(newStatus);
    if (onStatusChange) {
      onStatusChange(newStatus);
    }
  };

  // Determine styling based on status
  const getCardStyles = () => {
    if (currentStatus === 'attended') {
      return 'bg-green-50 border border-green-200 text-green-600';
    } else if (currentStatus === 'cancelled') {
      return 'bg-red-50 border border-red-200 text-red-600';
    }
    // Inactive state
    return 'bg-[#F1F1F1] border border-gray-200 text-gray-600';
  };

  return (
    <div
      className={`w-full rounded-lg p-3 mb-4 flex flex-col justify-between sm:flex-row gap-2 sm:items-center ${getCardStyles()}`}
      role="alert"
    >
      <p className="text-sm font-normal">This appointment held?</p>

      <div className="flex gap-2 sm:items-center sm:justify-end">
        <button
          className={`px-3 py-1 w-full sm:w-fit rounded-md h-[38px] text-sm font-medium flex items-center gap-2 transition-colors ${currentStatus === 'cancelled'
              ? 'bg-red-50 border border-[#E12121] text-[#202020CC]'
              : currentStatus === 'attended'
                ? 'bg-gray-100 border border-gray-300 text-gray-400 cursor-not-allowed'
                : 'bg-white text-[#202020CC] hover:bg-gray-50'
            }`}
          onClick={() => handleStatusUpdate('cancelled')}
          disabled={currentStatus === 'attended'}
        >
          <X className={`w-4 h-4 ${currentStatus === 'attended' ? 'text-gray-400' : 'text-red-500'}`} />
          No, Not Held
        </button>

        <button
          className={`px-3 py-1 w-full sm:w-fit rounded-md h-[38px] text-sm font-medium flex items-center gap-2 transition-colors ${currentStatus === 'attended'
              ? 'bg-green-50 border border-[#019939] text-[#202020CC]'
              : currentStatus === 'cancelled'
                ? 'bg-gray-100 border border-gray-300 text-gray-400 cursor-not-allowed'
                : 'bg-white text-[#202020CC] hover:bg-gray-50'
            }`}
          onClick={() => handleStatusUpdate('attended')}
          disabled={currentStatus === 'cancelled'}
        >
          <img
            src="/icons/check-icon.svg"
            alt="Check-icon"
            className={`w-4 h-4 ${currentStatus === 'cancelled' ? 'opacity-40' : ''}`}
          />
          Yes, It Held
        </button>
      </div>
    </div>
  );
}